export { PageNews } from './News';
